// src/constants/reportSchema.js
// Faz 1D Görev 3 — İçerik şikayet (content report) sözleşmesi.
//
// Tek kaynak; client UI, validator ve Cloud Function tarafından import edilir.
// Yeni reason/target tipi eklerken `functions/src/content_reports.ts` içindeki
// allow-listing'i de güncelle.

export const REPORT_TARGET_TYPE = Object.freeze({
  CLIP: "clip",
  COMMENT: "comment",
  REPLY: "reply",
  USER: "user",
  // 🔴 EKSİKTİ (ölçüldü 2026-08-24): gönderiler ŞİKAYET EDİLEMİYORDU.
  // `Post.tsx` / `PostMobile.tsx` kebab menülerinde "Şikayet et" satırı yoktu
  // ve şema `post`u tanımadığı için callable da reddederdi. IG paritesinde
  // her gönderinin şikayet yolu vardır; ayrıca moderasyon hattının tek
  // kullanıcı-tetikli girişi budur.
  POST: "post",
});

export const REPORT_REASON = Object.freeze({
  SPAM: "spam",
  HARASSMENT: "harassment",
  HATE: "hate",
  SEXUAL: "sexual",
  VIOLENCE: "violence",
  ILLEGAL: "illegal",
  FAKE_ACCOUNT: "fake_account",
  INAPPROPRIATE: "inappropriate",
  OTHER: "other",
});

export const REPORT_STATUS = Object.freeze({
  OPEN: "open",
  REVIEWED: "reviewed",
  ACTIONED: "actioned",
  DISMISSED: "dismissed",
});

// Whitelist (array) — client select + rule/callable validator kullansın.
export const REPORT_TARGET_TYPE_LIST = Object.freeze(
  Object.values(REPORT_TARGET_TYPE)
);
export const REPORT_REASON_LIST = Object.freeze(Object.values(REPORT_REASON));

// Detail metni sınırı — admin okunabilirlik + abuse koruması.
export const REPORT_DETAIL_MAX_LENGTH = 300;

// TR UI label'ları — ReportModal select'i bunu gösterir (Görev 4).
export const REPORT_REASON_LABEL_TR = Object.freeze({
  [REPORT_REASON.SPAM]: "Spam / rahatsız edici",
  [REPORT_REASON.HARASSMENT]: "Taciz / hakaret",
  [REPORT_REASON.HATE]: "Nefret söylemi",
  [REPORT_REASON.SEXUAL]: "Cinsel içerik",
  [REPORT_REASON.VIOLENCE]: "Şiddet",
  [REPORT_REASON.ILLEGAL]: "Yasadışı içerik",
  [REPORT_REASON.FAKE_ACCOUNT]: "Sahte hesap",
  [REPORT_REASON.INAPPROPRIATE]: "Uygunsuz içerik",
  [REPORT_REASON.OTHER]: "Diğer",
});

// Faz 0 / G0-1 — Kullanıcı şikayetinde sunulan kısa whitelist (App Store /
// Play Store user-report ekran tasarımına uyumlu). ReportUserModal bu listeyi
// kullanır; geri kalan reason'lar yorum/klip akışına özeldir.
export const REPORT_USER_REASON_LIST = Object.freeze([
  REPORT_REASON.SPAM,
  REPORT_REASON.HARASSMENT,
  REPORT_REASON.FAKE_ACCOUNT,
  REPORT_REASON.INAPPROPRIATE,
  REPORT_REASON.HATE,
  REPORT_REASON.OTHER,
]);

// Dedup docId: {reporterUid}_{targetType}_{targetId}.
// Aynı kullanıcı aynı hedef için tek açık rapor tutabilir; tekrar gönderim
// mevcut doc'u overwrite eder (Firestore rules create check'i geçer).
export function buildReportDocId({
  reporterUid,
  targetType,
  targetId,
}: {
  // Gövdenin kendi savunması `String(x || "")` — her üç alan da eksik/serbest
  // tipte gelebilir, o yüzden imza gövdeden DAR yazılmadı.
  reporterUid?: unknown;
  targetType?: unknown;
  targetId?: unknown;
}) {
  const parts = [String(reporterUid || ""), String(targetType || ""), String(targetId || "")];
  return parts
    .map((p) => p.replace(/[^a-zA-Z0-9_-]/g, "_").slice(0, 150))
    .join("_");
}
